import { useThree } from "@react-three/fiber";
import { useEbbnenContext } from "@solidwhite/ebbnen";
import { useEffect } from "react";

const CamNearFarSetter = ({ ...props }) => {
  const { currentLayer } = useEbbnenContext();

  const { camera } = useThree();

  useEffect(() => {
    if (currentLayer <= 2) {
      camera.near = 1;
    } else {
      camera.near = 0.03;
    }
  }, [currentLayer]);

  return null;
};

export default CamNearFarSetter;
